<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.especialidade"
                    :request-query-string-params="{ not_id: especialidadesReguladasIds }"
                    :search-fields="fields.especialidade"
                    :validations="validations.especialidade"
                    label="Especialidade"
                    :text-field="e => `${e.codigo} - ${e.nome}`"
                    uppercase
                    v-model="model.especialidade"
                />
            </rkm-col>

            <rkm-form-checkbox
                v-model="model.exigeDocumentoAnexo"
                :label="false"
            >
                Exige documento anexo
            </rkm-form-checkbox>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    {{ especialidade ? 'Atualizar' : 'Incluir' }}
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                especialidade: { required: true },
            }
        },
        especialidadesReguladasIds() {

            return this.regulador.especialidades.map(e => e.id)
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            especialidade: [
                { key: 'ocupacao.codigo', searchable: true },
                { key: 'especialidade.nome', searchable: true },
            ],
        },
        model: {
            especialidade: null,
            exigeDocumentoAnexo: false,
            isUpdate: false,
        }
    }),
    methods: {
        add() {

            if (this.model.isUpdate) {

                const index = this.regulador.especialidades.findIndex(e => e.id === this.model.especialidade.id)

                if (index !== -1) {
                    
                    const updatedEspecialidade = {
                        ...this.regulador.especialidades[index],
                        exigeDocumentoAnexo: this.model.exigeDocumentoAnexo
                    }

                    this.$emit('especialidadeUpdate', updatedEspecialidade)
                    this.regulador.especialidades.splice(index, 1, updatedEspecialidade)
                }

                this.model.isUpdate = false
                this.model.especialidade = null
                this.model.exigeDocumentoAnexo = false

                this.resetForm()
            } else {

                this.regulador.especialidades.push(this.prepareData())

                this.resetForm()
            }
        },
        prepareData() {

            const especialidade = this.clone(this.model.especialidade)

            especialidade.exigeDocumentoAnexo = this.model.exigeDocumentoAnexo
            this.model.exigeDocumentoAnexo = false

            especialidade.ativo = true

            return especialidade
        },
        resetForm() {

            this.model.especialidade = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [repository, object],
    props: {
        regulador: { type: Object, required: true },
        especialidade: { type: Object, default: null },
    },
    watch: {
        especialidade: {
            handler(newValue) {

                if (newValue) {

                    this.model.isUpdate = true
                    this.model.especialidade = this.clone(newValue)
                    this.model.exigeDocumentoAnexo = newValue.exigeDocumentoAnexo
                } else {
                    
                    this.model.isUpdate = false
                    this.model.especialidade = null
                    this.model.exigeDocumentoAnexo = false
                }
            },
            immediate: true
        }
    },
}
</script>